import React from "react";
import SkeletonLoader from "shrimmer/SkeletonLoader";

const MySurveyShrimmer = () => {
  return (
    <>
      {Array.from({ length: 6 }, (_, index) => (
        <div className="item" key={`cms_content_shrimmer_${index}`}>
          <div className="surveys_card">
            <div className="head">
              <p>
                <span>
                  <SkeletonLoader type={"text"} count={1} height={25} width={230} />
                </span>
                <b>
                  <SkeletonLoader type={"text"} count={1} height={28} width={350} />
                </b>
              </p>
            </div>
            <div className="survey_content">
              <p>
                <SkeletonLoader
                  type={"text"}
                  count={2.75}
                  height={22}
                  width={450}
                  bottomGap={6}
                />
              </p>
              <ul className="survey_duration">
                <li>
                  <span>
                    <SkeletonLoader
                      type={"text"}
                      count={1}
                      height={20}
                      width={110}
                    />
                  </span>
                  <SkeletonLoader type={"text"} count={1} height={20} width={80} />
                </li>
                <li>
                  <span>
                    <SkeletonLoader
                      type={"text"}
                      count={1}
                      height={20}
                      width={110}
                    />
                  </span>
                  <SkeletonLoader type={"text"} count={1} height={20} width={80} />
                </li>
              </ul>

              <ul className="participants">
                <li>
                  <SkeletonLoader type={"text"} count={1} height={20} width={20} />
                  <span>
                    <SkeletonLoader type={"text"} count={1} height={20} width={100} />
                  </span>
                </li>
                <li>
                  <SkeletonLoader type={"text"} count={1} height={20} width={20} />
                  <span>
                    <SkeletonLoader type={"text"} count={1} height={20} width={100} />
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default MySurveyShrimmer;
